// Global Smart Links activity feed — recent events across ALL of the tenant's
// links (every click / install / open), newest first. Backed by GET /links/activity.
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Flex, Heading, Text, HStack, Select, Button, Spinner, Center } from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi';
import { useGetActivityQuery } from '../store/linksApi';
import { ActivityLog } from '../components/analytics/ActivityLog';

export const ActivityPage: React.FC = () => {
  const [days, setDays] = useState(30);
  const { data, isLoading, isError, refetch } = useGetActivityQuery({ limit: 300, days });

  return (
    <Box>
      <Flex justify="space-between" align={{ base: 'start', md: 'center' }} mb={5} direction={{ base: 'column', md: 'row' }} gap={3}>
        <Box>
          <Button as={RouterLink} to=".." size="xs" variant="ghost" leftIcon={<FiArrowLeft />} mb={1}>
            All links
          </Button>
          <Heading size="md">Activity</Heading>
          <Text fontSize="sm" color="gray.500">Every click, install and open across all your Smart Links</Text>
        </Box>
        <HStack spacing={2}>
          <Select size="sm" width="140px" value={days} onChange={(e) => setDays(Number(e.target.value))}>
            <option value={1}>Last 24 hours</option>
            <option value={7}>Last 7 days</option>
            <option value={30}>Last 30 days</option>
            <option value={90}>Last 90 days</option>
          </Select>
        </HStack>
      </Flex>

      {isLoading ? (
        <Center py={16}><Spinner size="xl" color="blue.500" thickness="4px" /></Center>
      ) : isError ? (
        <Center py={16}>
          <Box textAlign="center">
            <Text color="gray.500" mb={3}>Couldn’t load activity.</Text>
            <Button size="sm" onClick={() => refetch()}>Retry</Button>
          </Box>
        </Center>
      ) : (
        <ActivityLog events={data?.events ?? []} showLink title="Recent activity — all links" />
      )}
    </Box>
  );
};
